// extracted by mini-css-extract-plugin
export default {"modal":"1040"};